import { saveEventDialogVar } from 'context'
import { IGraphDataPoint } from 'screens/UserDetails/Graph/types'

export const displaySaveEventDialog = (graphDataPoint: IGraphDataPoint) => {
  saveEventDialogVar({ open: true, graphDataPoint, event: undefined })
}
